import React from "react";
import { Link } from "react-router-dom";
import logo from "./logo.png";
import "./MainNavbar.css";
import { useAuth } from "../../Context/useAuth";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import LogedInTabs from "./LogedInTabs";
import LogedOutTabs from "./LogedOutTabs";

interface Props {}

const MainNavbar = (props: Props) => {
  const { isLoggedIn, user, logout } = useAuth();
  
  return (
    <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary shadow">
      <Container >
        <Navbar.Brand href="/">MTB Part Picker</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
        {isLoggedIn()
            ? <LogedInTabs />
            : <LogedOutTabs />}
          {isLoggedIn() ?
          <Nav>
            <Nav.Link>Welcome, {user?.username}</Nav.Link>
            <Nav.Link onClick={() => logout()} className="button">Logout</Nav.Link>
          </Nav>
            : <Nav>
                <Nav.Link href="/login">Login</Nav.Link>
            </Nav>
            }

            {/*isLoggedIn() == false && <Nav.Link href="/login">Logout</Nav.Link>*/}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MainNavbar;
